import React from 'react';
import * as messages from '../../messages';
import Card from '@material-ui/core/Card';
import classes from './../../index.css';
import CardHeader from '@material-ui/core/CardHeader';
import EmailIcon from "@material-ui/icons/EmailOutlined";

const signUpCompleted = (props) => (
    <Card className={classes.Form}>
        <CardHeader title={messages.SIGNUP_ALMOST_COMPLETED} className={classes.Head} />
        <EmailIcon fontSize="large" style={{fontSize: '70px', marginTop: '35px'}}/>
        <p style={{padding: '10px', textAlign: 'justify'}}>{messages.SIGNUP_COMPLETED}</p>
    </Card>
);

export default signUpCompleted;